import { errorHelpers } from '@approvalmax/utils';
import { memo, useCallback } from 'react';

import { Filter, FilterType } from '../../../../data/filters';
import { FilterDateRange } from '../FilterDateRange/FilterDateRange';
import { FilterNumberRange } from '../FilterNumberRange/FilterNumberRange';
import { FilterReferenceList } from '../FilterReferenceList/FilterReferenceList';
import { FilterReferenceValue } from '../FilterReferenceValue/FilterReferenceValue';
import { FilterTextValue } from '../FilterTextValue/FilterTextValue';
import { FilterUserList } from '../FilterUserList/FilterUserList';
import { FilterComponentProps } from './FilterComponent.types';

export const FilterComponent = memo<FilterComponentProps>((props) => {
    const { column, field, options, onChange, companyTeam } = props;

    const handleFilterChange = useCallback(
        (filter: Filter) => {
            onChange(column, filter);
        },
        [column, onChange]
    );

    switch (column.filter.type) {
        case FilterType.ReferenceList:
            return (
                <FilterReferenceList
                    columnId={column.id}
                    columnKind={column.kind}
                    filter={column.filter}
                    field={field}
                    options={options}
                    onFilterChange={handleFilterChange}
                />
            );

        case FilterType.ReferenceValue: {
            return (
                <FilterReferenceValue filter={column.filter} options={options} onFilterChange={handleFilterChange} />
            );
        }

        case FilterType.DateRange:
            return <FilterDateRange filter={column.filter} onFilterChange={handleFilterChange} />;

        case FilterType.NumberRange:
            return <FilterNumberRange filter={column.filter} onFilterChange={handleFilterChange} />;

        case FilterType.UserList:
        case FilterType.UserIdsList:
            return <FilterUserList filter={column.filter} options={companyTeam} onFilterChange={handleFilterChange} />;

        case FilterType.String:
            return <FilterTextValue filter={column.filter} onFilterChange={handleFilterChange} />;

        default:
            throw errorHelpers.invalidOperationError();
    }
});

FilterComponent.displayName = 'FilterComponent';
